<template>
  <div class="borrowMoneylist">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onSearch"
    >
      <el-button
        type="warning"
        icon="el-icon-download"
        @click="onHandleExport"
        slot="right"
        >导出</el-button
      >
    </Filtersearch>
    <!-- 表单搜索 end -->

    <!-- 列表 start -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          label="集配中心"
          prop="logisticBusinessValue"
          align="center"
        >
        </el-table-column>
        <el-table-column label="供货日期" prop="sales_cycle" align="center">
        </el-table-column>
        <el-table-column label="采购" prop="buyer.fullname" align="center">
        </el-table-column>
        <el-table-column label="供货商" prop="supplier.title" align="center">
        </el-table-column>
        <el-table-column label="商品名称" prop="sku_name" align="center">
        </el-table-column>
        <el-table-column label="货号" prop="sku_code" align="center">
        </el-table-column>
        <el-table-column label="销量(件)" prop="sales_volume" align="center">
        </el-table-column>
      </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import cloneDeep from "lodash/cloneDeep";
import {
  postBuyerSelectList,
  getSupplierSelectList,
} from "@/api/general/operation-center/index.js";
import { formatDate } from "@/utils/tools/date.js";
export default {
  name: "bestSelling",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logisticBusinessId",
          placeholder: "请选择集配中心",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "daterange",
          name: "供货时间",
          clearable: true,
          model: "timeRange",
          startmodel: "startTime",
          endmodel: "endTime",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          defaultValue: [
            formatDate(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)),
            formatDate(new Date()),
          ],
        },
        {
          type: "select",
          name: "采购",
          clearable: true,
          filterable: true,
          model: "buyerId",
          placeholder: "请选择采购",
          selectoptionname: "buyerList",
          label: "fullname",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "供应商",
          clearable: true,
          filterable: true,
          model: "supplierId",
          placeholder: "请选择供应商",
          selectoptionname: "supplierList",
          label: "title",
          value: "id",
          selectoption: [],
        },
        {
          type: "input",
          name: "货号",
          clearable: true,
          model: "skuCode",
          placeholder: "请输入货号",
        },
      ],
      supplierList: [],
      buyerList: [],
      loading: false,
      btndisabled: false,
      formData: {
        logisticBusinessId: "",
        startTime: formatDate(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)),
        endTime: formatDate(new Date()),
        buyerId: "",
        supplierId: "",
        skuCode: "",
        page: 1,
        pageSize: 10,
      },
      formDataClone: {},
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.getBusinessList();
    this.postAjaxBuyerSelectList();
    this.ajaxGetSupplierSelectList();
  },
  mounted() {
    this.onInitData();
  },
  methods: {
    getBusinessList() {
      this.$api.general.businessList().then((res) => {
        this.Filtersearchlist[0].selectoption = res.data;
      });
    },
    formatDateParam(date) {
      return date ? date.replace(/-/g, "") : "";
    },
    getSearchParams() {
      return {
        ...this.formData,
        startTime: this.formatDateParam(this.formData.startTime),
        endTime: this.formatDateParam(this.formData.endTime),
      };
    },
    ajaxGetTableList() {
      this.loading = true;
      this.$api.bestSelling
        .getHotSkuSalesVolumeStatistics(this.getSearchParams())
        .then((res) => {
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.ajaxGetTableList();
    },
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.ajaxGetTableList();
    },
    onSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.ajaxGetTableList();
    },
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.ajaxGetTableList();
    },
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.ajaxGetTableList();
    },
    /**
     * 获取业务下拉列
     */
    async postAjaxBuyerSelectList() {
      try {
        const { data } = await postBuyerSelectList();
        this.buyerList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "buyerList"
          ) {
            el.selectoption = [{ id: "", fullname: "全部" }, ...data];
          }
        });
      } catch (err) {
        console.log("ajax postBuyerSelectList err", err);
      } finally {
        // this.loadingBuyerList = false;
      }
    },
    /**
     * 获取供应商下拉列
     */
    async ajaxGetSupplierSelectList() {
      try {
        const { data } = await getSupplierSelectList();
        this.supplierList = data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "supplierList"
          ) {
            el.selectoption = [{ id: "", title: "全部" }, ...data];
          }
        });
      } catch (err) {
        console.log("ajax getSupplierSelectList err", err);
      } finally {
        // this.loadingSupplierList = false;
      }
    },
    //导出
    onHandleExport() {
      this.$api.bestSelling
        .getHotSkuSalesVolumeStatisticsExport(this.getSearchParams())
        .then((res) => {
          console.log(res);
          this.goExportCenter();
        });
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
  },
};
</script>
<style lang="scss">
.borrowMoneylist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .table-wrap {
    flex-grow: 1;
    overflow-y: hidden;
    .text-btn {
      color: $theme-color;
      cursor: pointer;
    }
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
